import { Action } from 'redux';
import { ReplyInterface } from './reply.interface';
import * as ReplyActions from './replay.actions';

export interface RefReplyState {
    currentReply: ReplyInterface;
}

const initialState: RefReplyState = {
    currentReply: {
        author: undefined,
        authorId: undefined,
        avatar: undefined,
        commendId: undefined,
        content: undefined,
        deleted: undefined,
        floor: undefined,
        liked: undefined,
        likes: undefined,
        published: undefined,
        replyId: undefined,
        userLevelSymbol: undefined,
        videoId: undefined,
    }
};

export const RefReplyReducer =
    function (state: RefReplyState = initialState, action: Action): RefReplyState {
        switch (action.type) {
            case ReplyActions.CLEARREFREPLY:
                // return initialState;
                return Object.assign({}, state, initialState);
            case ReplyActions.REFREPLY:
                //console.log(state);
                const refReply = (<ReplyActions.RefReplyAction>action).reply;
                // return { currentReply: Object.assign({}, state.currentReply, refReply) };
                return Object.assign({}, state, {currentReply: refReply});
            default:
                return state;
        }
    };

export const getRefReplyState = (state): RefReplyState => state.comments;
